<template>
    <ui-dialog
            :title="title"
            :isShow="isShowDalog"
            @closeDialog="closeDialog"
            @addOrEdit="submitForm"
    >
        <template #form>
            <el-form
                    ref="ruleFormRef"
                    :model="query"
                    :rules="rules"
                    label-width="80px"
            >
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="头像" prop="iconArr">
                            <ui-image :value="query.iconArr" @input="getImage"></ui-image>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户全名" prop="fullName">
                            <el-input v-model="query.fullName" placeholder="请输入客户全名" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="标签" prop="signature">
                            <el-input v-model="query.signature" placeholder="请输入标签" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址" prop="address">
                            <el-input v-model="query.address" placeholder="请输入地址" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="mobile">
                            <el-input v-model="query.mobile" placeholder="请输入手机号" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="座机" prop="tel">
                            <el-input v-model="query.tel" placeholder="请输入座机" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="城市" prop="city">
                            <el-input v-model="query.city" placeholder="请输入城市" clearable></el-input>
                        </el-form-item>
                    </el-col>
<!--                    <el-col :span="12">-->
<!--                        <el-form-item label="客户分组" prop="group">-->
<!--                            <el-select v-model="query.group" placeholder="请选择客户分组">-->
<!--                                <el-option v-for="(item,index) in groupTypeArray" :label="item" :value="item"></el-option>-->
<!--                            </el-select>-->
<!--                            <div style="margin-left: 10px;font-size: 20px;color: #999;margin-top: 4px;cursor: pointer" @click="groupType_handle"><el-icon><CirclePlus /></el-icon></div>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :span="12">
                        <el-form-item label="客户简称" prop="shortName">
                            <el-input v-model="query.shortName" placeholder="请输入客户简称" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别" prop="sex">
                            <el-input v-model="query.sex" placeholder="请输入性别" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="生日" prop="birthday">
                            <el-input v-model="query.birthday" placeholder="请输入生日" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="来源" prop="source">
                            <el-input v-model="query.source" placeholder="请输入来源" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="职务" prop="duties">
                            <el-input v-model="query.duties" placeholder="请输入职务" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="QQ" prop="qq">
                            <el-input v-model="query.qq" placeholder="请输入QQ" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="微信" prop="wechat">
                            <el-input v-model="query.wechat" placeholder="请输入微信" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="query.email" placeholder="请输入邮箱" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="传真" prop="fax">
                            <el-input v-model="query.fax" placeholder="请输入传真" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="行业" prop="industry">
                            <el-input v-model="query.industry" placeholder="请输入行业" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工作单位" prop="corporateName">
                            <el-input v-model="query.corporateName" placeholder="请输入工作单位" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="网址" prop="net">
                            <el-input v-model="query.net" placeholder="请输入网址" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="客户星级" prop="level">
                            <el-input v-model="query.level" placeholder="请输入客户星级" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="query.remark" placeholder="请输入备注" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>

    </ui-dialog>
    <el-dialog
            v-model="dialogVisible"
            title="新增分组"
            width="30%"
    >
        <el-input v-model="groupType" placeholder="请输入分组名称"></el-input>
        <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="submit_handle_groupType">
                      确定
                    </el-button>
              </span>
        </template>
    </el-dialog>
</template>

<script setup>
    import {
        defineComponent,
        onMounted,
        defineExpose,
        ref,
        computed,
        toRefs,
        reactive,
        defineProps,
        defineEmits,
        nextTick
    } from 'vue'
    import { ElMessage } from "element-plus"
    import {createHandle,updateHandle,detailHandle} from '@/api/customer'
    import {getProductList,createProTag,delProTagById,getProductTagTree,updateProTag} from '@/api/department'
    import {upload} from '@/api/upload'
    import ImageUploader from "quill-image-uploader";
    import {isPhone} from "../../utils/validate";
    const props = defineProps({
        isShow:{
            type:Boolean
        },
        title:{
            type:String,
            default:"详情"
        },
    })
    const hideUpload = ref(false)
    const isShowDalog = ref(false)
    let query = reactive({
        id:undefined,
        iconArr:[],
        icon:"",
        fullName: "",
        address: "",
        departmentName: "",
        department_id:"",
        signature: [],
        email:'',
        mobile: "",
        tel:'',
        city:'',
        group:"",
        shortName:"",
        sex:'',
        birthday:"",
        source:"",
        duties:"",
        qq:"",
        wechat:"",
        industry:"",
        fax:"",
        corporateName:'',
        net:"",
        level:"",
        remark:'',
    })
    const rules = reactive({
        fullName: [
            {
                required: true,
                message: '请输入客户全名',
                trigger: 'blur',
            },
        ],
        mobile: [
            {
                required: true,
                message: '请输入手机号',
                trigger: 'blur',
                validator:valiPhone

            }
        ],
        city: [
            {
                required: true,
                message: '请输入城市',
                trigger: 'blur',
            },
        ],
    })
    const valiPhone = (rule, value, callback) => {
        console.log(value)
        if(!isPhone(value)){
          callback(new Error('请输入正确的11位手机号'));
        }else{
          callback()
        }
    }
    let isShowRight = ref(false)
    let getTreeRef = ref(null)
    const defaultProps = {
        children: 'children',
        label: 'name',
    }
    function selectParentEle(){
        isShowRight.value = true
    }
    function handleNodeClick(e){
        query.department_id = e.id
        query.departmentName = e.name
    }
    function closeRightHandle(){
        isShowRight.value = false
    }
    function openedDrawer(){
        getTreeRef.value.setCurrentKey(query.pid,true)
        nextTick(() => {
            getTreeRef.value.setCurrentKey(query.pid,true)
        })
    }
    let data = ref([])
    function getProductTagTreeHandle(){
        getProductTagTree().then(res=>{
            data.value = res.data
        })
    }
    const closeDialog = () => {
        emit("closeDialog")
    }
    const ruleFormRef = ref(null)
    const submitForm = () => {
        ruleFormRef.value.validate((valid) => {
            if (valid) {
                let params = query
                if(query.id){
                    updateForm(params)
                }else{
                    addForm(params)
                }
                closeDialog()
            } else {
                return false
            }
        })
    }
    const addForm = (form)  => {
        createHandle(form).then((data) => {
            if(data.code == 200){
                ElMessage({
                    showClose: true,
                    message: '添加成功',
                    type: 'success',
                })
                closeDialog()
                emit('refreshDataList')
            }

        })
    }
    const updateForm = (form)  => {
        updateHandle(form).then((data) => {
            if(data.code == 200){
                ElMessage({
                    showClose: true,
                    message: '更新成功',
                    type: 'success',
                })
                closeDialog()
                emit('refreshDataList')
            }

        })
    }
    function getImage(val){
        console.log(val)
        query.icon = val[0]
    }
    //编辑---初始化数据
    const init = (id) => {
        isShowDalog.value = props.isShow
        // getProductTagTreeHandle()
        if(id){
            query.id = id
            detailHandle({id:id}).then(data => {

                query.fullName = data.data.fullName
                query.address = data.data.address
                query.signature = data.data.signature
                query.email = data.data.email
                query.mobile = data.data.mobile
                query.tel = data.data.tel
                query.city = data.data.city
                query.group = data.data.group
                query.shortName = data.data.shortName
                query.sex = data.data.sex
                query.birthday = data.data.birthday
                query.source = data.data.source
                query.duties = data.data.duties
                query.qq = data.data.qq
                query.wechat = data.data.wechat
                query.industry = data.data.industry
                query.fax = data.data.fax
                query.corporateName = data.data.corporateName
                query.net = data.data.net
                query.level = data.data.level
                query.remark = data.data.remark,
                query.iconArr = [{
                    url:data.data.icon
                }]
                query.icon = data.data.icon
            })
        }else{
            console.log('无id')
        }
    }
    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
        ['blockquote', 'code-block'], //引用，代码块
        [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
        [{ 'list': 'ordered' }, { 'list': 'bullet' }], //列表
        [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
        [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
        [{ 'direction': 'rtl' }], // 文本方向
        [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], //几级标题
        [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
        [{ 'font': [] }], //字体
        [{ 'align': [] }], //对齐方式
        ['clean'], //清除字体样式
        ['image'] //上传图片、上传视频
    ];
    const modules = {
        name: 'imageUploader',
        modules:{
            toolbar:{
                container:toolbarOptions,
                handlers:{
                    "image":file => {
                        //此处需要input输入框和文本编辑器配合使用
                        //出发点击事件
                        document.getElementById('fileToRichText').click()
                        //监听input框变化
                        document.getElementById('fileToRichText').addEventListener('change', uploadImage);
                    }
                }
            }
        }
    }
    function uploadImage(){
        var fileInput = document.getElementById('fileToRichText');
        var file = fileInput.files[0];
        var formData = new FormData();
        // 将文件添加到FormData对象
        formData.append('file', file);
        upload(formData).then(data=>{
            console.log("上传成功")
            let quill = quillRef.value.getQuill()
            let length = 0
            if(quill.getSelection() != null){
                length = quill.getSelection().index
            }
            quill.insertEmbed(length,'image',data.data);
            quill.setSelection(length+1)
        })
    }
    let dialogVisible = ref(false)
    let groupType = ref("")
    let groupTypeArray = ref([])
    function groupType_handle(){
        console.log(111)
        dialogVisible.value = true
    }
    function submit_handle_groupType(){
        groupTypeArray.value.push(groupType.value)
        dialogVisible.value = false
    }
    let quillRef = ref(null)
    //定义父组件需要调用的方法
    defineExpose({
        init
    })
    onMounted( () => {

    })
    const emit = defineEmits(["closeDialog","refreshDataList"])
</script>

<style lang="scss" scoped>
    .title{
        background: #ededed;
        padding: 10px 0;
        margin-bottom: 20px;
        p{
            width: 98%;
            margin: 0 auto;
        }
    }
    .editor{
        width: 100%;
    }
</style>
